<template>
  <div id="resgiter" :style="background">
    <div class="el-res-form">
      <div class="el-res-text">
        <h4>欢迎注册使用<br/>中欧铁路运踪查询系统</h4>
        <div class="el-res-text-inner"></div>
        <router-link class="el-link-login" :to="{path: '/login'}">{{haveId}}
          <span class="loginBig">登录</span>  
        </router-link>
        <span class="el-text-form-copyright">运踪信息查询平台 Copyright © 2014-2021</span>
      </div>
      <div class="el-resg-form">
        <div class="el-sub-resg">
          <div class="el-cont-form">
            <el-form
              :model="registerForm"
              :rules="rules"
              status-icon
              ref="registerForm"
              class="register-Form">
              <el-form-item label prop="regNam" class="el-lin">
                <el-input
                  v-model="registerForm.regNam"
                  type="text"
                  placeholder="请输入用户名">
                  <template slot="prepend">
                    <div class="el-icon-user el-icon-text"></div>
                  </template>
                  </el-input>
              </el-form-item>
              <el-form-item label prop="regPwd" class="el-lin">
                <el-input
                  v-model="registerForm.regPwd"
                  type="password"
                  placeholder="请输入密码">
                  <template slot="prepend">
                    <div class="el-icon-lock el-icon-text"></div>
                  </template>
                  </el-input>
              </el-form-item>
              <!-- <el-form-item label prop="regCoaypwd" class="el-lin">
                <div class="el-regicoNam">
                  <i class="el-icon-lock"></i>
                </div>
                <el-input
                  v-model="registerForm.regCoaypwd"
                  type="password"
                  placeholder="确认密码"
                ></el-input>
              </el-form-item> -->
              <el-form-item label prop="regPhone" class="el-lin">
                <el-input
                  v-model="registerForm.regPhone"
                  type="text"
                  placeholder="请输入手机号">
                  <template slot="prepend">
                    <div class="el-icon-mobile-phone el-icon-text"></div>
                  </template>
                  </el-input>
              </el-form-item>
              <el-form-item label prop="regEmail" class="el-lin">
                <el-input
                  v-model="registerForm.regEmail"
                  type="text"
                  placeholder="请输入邮箱账号">
                  <template slot="prepend">
                    <div class="el-icon-message el-icon-text"></div>
                  </template>
                  </el-input>
              </el-form-item>
              <el-form-item label prop="regVercode" class="el-lin">
                <el-input
                  @keyup.enter.native="submitForm('registerForm')"
                  v-model="registerForm.regVercode"
                  type="text"
                  placeholder="请输入验证码">
                  <template slot="append">
                    <el-button
                    type="info"
                    plain
                    @click="butTime"
                    :loading="loadings">
                    {{regbutxt}}
                    <span v-if="loadings">s</span>
                    </el-button>
                  </template>
                  </el-input>
                <!-- <div class="el-regBut" :style="regBut">
                  <el-button
                    style="width: 100%"
                    type="info"
                    plain
                    @click="butTime"
                    :loading="loadings">
                    {{ regbutxt }}
                    <span v-if="loadings">s</span>
                  </el-button>
                </div> -->
              </el-form-item>
              <el-form-item>
                <el-button
                  style="width: 100%"
                  type="primary"
                  @click="submitForm('registerForm')"
                  :loading="loading">
                  立即注册
                  </el-button>
              </el-form-item>
              <!-- <el-form-item :style="haveColor">
                <router-link
                :style="haveColor"
                :to="{path: '/login'}">
                {{haveId}}
                </router-link>
              </el-form-item> -->
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//引入验证规则
import {
  isvalidUsername,
  isvalidPhone,
  isvalidPass,
  isvalidEmail,
} from "./reg/validation.js";
export default {
  name: "Resgiter",
  data() {
    let validUsername = (rule, value, callback) => {
      //校验用户名
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else if (!isvalidUsername(value)) {
        callback(new Error("用户名为5-16个字母或数字"));
      } else {
        callback();
      }
    };
    let validatePass = (rule, value, callback) => {
      //校验密码
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!isvalidPass(value)) {
        callback(new Error("密码为6-18位之间的字母或者数字"));
      } else {
        if (this.registerForm.regCoaypwd !== "") {
          this.$refs.registerForm.validateField("regCoaypwd");
        }
        callback();
      }
    };
    // let validatePass2 = (rule, value, callback) => {
    //   //校验确认密码
    //   if (value === "") {
    //     callback(new Error("请再次输入密码"));
    //   } else if (value !== this.registerForm.regPwd) {
    //     callback(new Error("请保证两次密码一致!"));
    //   } else {
    //     callback();
    //   }
    // };
    let validPhone = (rule, value, callback) => {
      //校验手机号
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!isvalidPhone(value)) {
        callback(new Error("请规范手机号码"));
      } else {
        callback();
      }
    };
    let validEmail = (rule, value, callback) => {
      //校验邮箱账号
      if (value === "") {
        callback(new Error("请输入邮箱账号"));
      } else if (!isvalidEmail(value)) {
        callback(new Error("请规范邮箱账号"));
      } else {
        callback();
      }
    };
    return {
      background: {
        background: "url(./static/images/register_bg.jpg) no-repeat center center",
      },
      welcome: "欢迎注册",
      haveId: "已有账号？请立即前往",
      haveColor: {
        "font-size": "14px",
        color: "#409eff",
        "text-align": "center",
      },
      loading: false,
      loadings: false,
      regbutxt: "获取邮箱验证码",
      timer: null,
      registerForm: {
        regNam: "",
        regPwd: "",
        regCoaypwd: "",
        regPhone: "",
        regEmail: "",
        regVercode: "",
      },
      regBut: {
        display: "inline-block",
        "vertical-align": "top",
        width: "42%",
      },
      rules: {
        regNam: [{ required: true, validator: validUsername, trigger: "blur" }],
        regPwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        // regCoaypwd: [
        //   { required: true, validator: validatePass2, trigger: "blur" },
        // ],
        regPhone: [
          { required: true, validator: validPhone, trigger: "blur" },
          { min: 11, max: 11, trigger: "blur" },
        ],
        regEmail: [{ required: true, validator: validEmail, trigger: "blur" }],
        regVercode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      msg: "", //注册状态
      tokens: "", //注册token
    };
  },
  mounted() {},
  methods: {
    //点击获取邮箱验证码倒计时
    butTime() {
      const timecont = 59;
      if (!this.timer) {
        this.regbutxt = timecont;
        this.loadings = true;
        this.timer = setInterval(() => {
          if (this.regbutxt > 1 && this.regbutxt <= timecont) {
            this.regbutxt--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.loadings = false;
            this.regbutxt = "获取邮箱验证码";
          }
        }, 1000);
      }
      //获取验证码
      // this.$axios.defaults.baseURL = "http://192.168.0.161:81/api/";
      this.$axios
        .post("login/sendEmailCode", {
          username: this.registerForm.regNam,
          password: this.registerForm.regPwd,
          email: this.registerForm.regEmail,
        })
        .then((res) => {
          this.tokens = res.data.data.checktoken; //拿取token值
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //点击提交按钮
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.registerUser(); //触发注册
        }
        setInterval(() => {
          this.loading = false;
        }, 2000);
        return false;
      });
    },
    //用户注册
    registerUser() {
      // this.$axios.defaults.baseURL = "http://192.168.0.161:81/api/";
      this.$axios
        .post("login/register", {
          username: this.registerForm.regNam,
          password: this.registerForm.regPwd,
          phone: this.registerForm.regPhone,
          email: this.registerForm.regEmail,
          emailCode: this.registerForm.regVercode,
          checktoken: this.tokens,
        })
        .then((res) => {
          if (res.data.code == 400) {
            this.$message({
              message: res.data.msg, //弹出返回信息
              type: "warning",
              offset: 150,
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "success",
              offset: 150,
            });
            this.$router.push("/login"); //注册成功后跳转到登录页
          }
        })
        .catch((err) => {
          this.$message({
            message: "服务器错误",
            type: "warning",
            offset: 150,
          });
        });
    },
  },
};
</script>
<style>
  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
  }
</style>
<style scoped>
@import "./reg/resgiter.css";
</style>



// WEBPACK FOOTER //
// src/components/resgiter/resgiter.vue